import LogoEditorTool from '../../logo-editor/componenets/LogoEditorTool'
import { useLogoEditViewUpdateDesignViewModel } from '../vmHooks/useLogoEditViewUpdateDesignViewModel'

export function LogoEditViewUpdateDesignWrapper() {
  const vm = useLogoEditViewUpdateDesignViewModel()
  return <LogoEditorTool {...vm} isInDesignEditor={true} />
}